import { render, staticRenderFns } from "./ScheduleComment.vue?vue&type=template&id=36cd6c38&scoped=true&"
import script from "./ScheduleComment.vue?vue&type=script&lang=ts&"
export * from "./ScheduleComment.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduleComment.vue?vue&type=style&index=0&id=36cd6c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cd6c38",
  null
  
)

export default component.exports